// Failures that say something about the browser or the platform rather than about this app,
// and that a caller can do nothing with:
// - NotAllowedError: the user declined or dismissed the notification prompt.
// - AbortError: the browser's push service refused or could not be reached ("Registration
//   failed - push service error"), which also covers Chrome builds shipping without one.
const EXPECTED_ERROR_NAMES = ['NotAllowedError', 'AbortError'];

export default function isExpectedServiceWorkerError(error: unknown) {
  if (!(error instanceof DOMException)) {
    return false;
  }

  return EXPECTED_ERROR_NAMES.includes(error.name);
}
